import { put, call, take, fork } from 'redux-saga/effects'
import { editCourseCollectionIndexService } from '../../api/collection'
import { editCourseCollectionIndexSuccess } from '../../reducers/collection/action'
import { EDIT_COURSE_COLLECTION_INDEX } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* editCourseCollectionIndexFlow(payload) {
  try {
    const { entity, callback } = payload

    const response = yield call(editCourseCollectionIndexService, entity)
    yield put(editCourseCollectionIndexSuccess(response.data))

    // Invalidate the badge-list cache so that the next time the collection
    // landing-page renders the badge list (CreateBadgeList), it re-fetches the
    // badges and courses fresh and rebuilds in the new course order — without a
    // manual page refresh. (The badge list itself sorts by courseCollectionOrder.)
    window.badgeListNeedsRefresh = true

    yield put(operationSuccess())
    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* editCourseCollectionIndexWatcher() {
  while (true) {
    const action = yield take(EDIT_COURSE_COLLECTION_INDEX)
    const { payload } = action

    yield fork(generalSaga, editCourseCollectionIndexFlow, payload)
  }
}
